import { render, staticRenderFns } from "./import-store.vue?vue&type=template&id=7877cade"
import script from "./import-store.vue?vue&type=script&lang=js"
export * from "./import-store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports